import { axiosInstance } from "../config/swr";

/**
 * Admin API:
 * - GET  /agents?status=&limit=&offset=
 * - POST /agents/status
 * - GET  /agent-loan-rules?companyStatus=&productType=
 * - POST /agent-loan-rules
 */

export async function getAgents({ status, limit = 50, offset = 0 } = {}) {
  const params = { limit, offset };
  if (status) params.status = status;

  const res = await axiosInstance.get("/agents", { params });
  return res.data; // { items, total, limit, offset }
}

/**
 * body: { agentId, action, reason? }
 */
export async function updateAgentStatus(payload) {
  const res = await axiosInstance.post("/agents/status", payload);
  return res.data; // { ok, agentId, oldStatus, newStatus }
}

/**
 * GET single rule (required params)
 */
export async function getAgentLoanRule({ companyName, productType }) {
  const res = await axiosInstance.get("/agent-loan-rules", {
    params: { companyName, productType },
  });
  return res.data; // AgentLoanRule object
}

/**
 * POST upsert rule
 */
export async function upsertAgentLoanRule(payload) {
  const res = await axiosInstance.post("/agent-loan-rules", payload);
  return res.data; // AgentLoanRule object
}

// --- Agent Monitoring / Dashboard ---

export async function getAgentActivities({ agentId, limit = 50, offset = 0 } = {}) {
  const res = await axiosInstance.get(`/agents/${agentId}/activities`, {
    params: { limit, offset },
  });
  return res.data; // array of actions
}

export async function getAgentSummary({ days = 30 } = {}) {
  const res = await axiosInstance.get("/dashboard/agent-summary", {
    params: { days },
  });
  return res.data; // summary response
}

export async function downloadAgentsReportPDF({ days = 30 } = {}) {
  const res = await axiosInstance.get("/reports/agents.pdf", {
    params: { days },
    responseType: "blob",
  });
  return res.data; // Blob
}

export async function downloadDSAOnboardedCustomersCSV({ days = 30 } = {}) {
  const res = await axiosInstance.get("/reports/dsa-onboarded-customers.csv", {
    params: { days },
    responseType: "text",
  });
  return res.data;
}

export async function listAgentLoanRules() {
  const res = await axiosInstance.get("/agent-loan-rules/all");
  return res.data; // array of AgentLoanRule
}
